import React, { Component } from 'react'
import { Skeleton, Image } from 'antd'
import Col from 'react-bootstrap/Col'
import './btcDepositar.css'
// import '../../wallet.css'
// import '../brlDepRes.css'
import attach from '../../../../images/attach.png'
import QRCode from 'qrcode.react'
import { message } from 'antd'
import {CopyToClipboard} from 'react-copy-to-clipboard';

class Depositar extends Component {
    constructor(props) {
    super(props)
    this.state = {
    }}
        render() {
            return (
    
                <>                 
                    <div>
                            <Col md={12}>
                                <label className='tituloDadosBtc'>Dados da sua carteira Ribus</label>  
                                    <label className="tx-grey">- Este é um endereço de rede Polygon.<br /><br />- Não envie RIB por qualquer outra rede para este endereço ou seus fundos podem ser perdidos.</label>
                                    <div className="mt-5"> 
                                        <div className='linhaDadosBtc'>
                                            <div><label className='tituloInfoDepBtc'>Chave Pública</label></div>
                                            <div><label className='infoDepBtc'>{!this.props.isLoading ? this.props.userLogged.Wallets[0].enderecoWallet : <Skeleton active title={{width: 350}} paragraph={false} />}</label>
                                            <CopyToClipboard text={!this.props.isLoading ? this.props.userLogged.Wallets[0].enderecoWallet : ''}
                                                    onCopy={() => message.success('Copiado')}>
                                                    <div><label className='copiarInfo'>Copiar</label></div>
                                                </CopyToClipboard> 
                                            </div>
                                            <div>
                                                
                                            </div>                                      
                                        </div>      

                                        <hr className='linhaHorizontal'/>
                                    </div>                                
                            </Col>

                            <Col md={3} id="qrCodeCol">
                                <div><label className='tituloInfoDepBtc'>QR Code</label></div>
                                {this.props.isLoading ? <Skeleton active avatar={{shape: 'square', size: '500px'}} title={false} paragraph={false} /> : 
                                <QRCode id="qrCode" value={this.props.userLogged.Wallets[0].enderecoWallet} size={180} />}
                            </Col>

                    </div>
                </>
            )
        }
    }

export default Depositar